// src/components/Sidebar.js
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSideBarContext } from '../context/SidebarContext';
import usePreviousLocation from '../hooks/previousPathTrack';
// import { useSideBarContext } from '../context/SideBarContext';
// import $ from 'jquery';

const Sidebar = () => {
    const location = useLocation();
    const prevLocation = usePreviousLocation();

    const { isSidebarHidden, toggleSidebar } = useSideBarContext();
    const [orderOpen, setOrderOpen] = useState(false);
    const [activeOrder, setActiveOrder] = useState(false);
    // // useEffect(() => {
    // //     $(".closeBtn").on("click", function () {
    // //         $(".side-navbar").toggleClass("side-hide");
    // //         $(".main-wrapper").toggleClass("main-width");
    // //     });
    // //     return () => {
    // //         $(".closeBtn").off("click");
    // //     };
    // // }, []);

    // const isActive = (path) => location.pathname === path ? 'active' : '';

    const isOrderPage = location.pathname === ('/admin-dashboard/order-management');

    const isActive = useCallback((paths, exact = false) => {
        if (exact) {
            return paths.includes(location.pathname) ? 'active' : '';
        } else {
            return paths?.some(path => location.pathname.startsWith(path)) ? 'active' : '';
        }
    }, [location.pathname]);

    const isActive2 = useCallback(() => {
        return prevLocation === '/admin-dashboard/restaurants-management' ? 'active' : '';

    }, [prevLocation, location.pathname])

    const isActive3 = useCallback(() => {
        return prevLocation === '/admin-dashboard/customer-management' ? 'active' : '';

    }, [prevLocation, location.pathname])

    const childNavActive = useCallback((path, role) => {
        return (location.pathname === path && location.state?.role === role) ? 'active2' : '';
    }, [location.pathname, location.state]);

    const sidebarClass = useMemo(() => `side-navbar ${isSidebarHidden ? 'side-hide' : ''}`, [isSidebarHidden]);

    useEffect(() => {
        setActiveOrder(false);
    }, [location.pathname])

    useEffect(() => {
        const collapseElement = document.getElementById('navOrderManagement');
        const pathIsOrderManagement = location.pathname.includes('/order-management');

        if (collapseElement) {
            // Bootstrap's Collapse instance
            const collapseInstance = window.bootstrap.Collapse.getOrCreateInstance(collapseElement);

            // Hide the collapse if we navigated away from order-management
            if (!pathIsOrderManagement && collapseElement.classList.contains('show')) {
                collapseInstance.hide();
            }
        }
    }, [location.pathname]);

    useEffect(() => {
        if (prevLocation === '/admin-dashboard/restaurants-management') {
            isActive2()
        }
    }, [prevLocation])

    useEffect(() => {
        if (location.pathname === '/admin-dashboard/order-management') {
            setOrderOpen(true);
        } else {
            setOrderOpen(false);
        }
    }, [location.pathname]);
    return (
        <div className={sidebarClass}>
            <button className="closeBtn" onClick={toggleSidebar}>
                <i className="fa-solid fa-times"></i>
            </button>
            <ul className="nav flex-column position-relative" id='sidebar-nav'>
                <li className="nav-item sidebar-logo">
                    {/* <a className="navbar-brand text-white" href="#">
                        <img src="/assets/images/statzo-logo.svg" alt="Logo" />
                    </a> */}
                    <h1 style={{ color: 'black' }}>LOGO</h1>
                </li>
                <li className="nav-item sidebar-link">
                    <Link className={`nav-link ${isActive(['/admin-dashboard'], true)}`} to="/admin-dashboard">
                        <span className="nav-icon">
                            <img src="/assets/icons/dashboard.svg" alt="Dashboard" />
                            {/* <i class="fa-solid fa-house"></i> */}
                        </span>
                        <span className="nav-text">
                            Dashboard
                        </span>
                    </Link>
                </li>
                <li className="nav-item sidebar-link">
                    <Link className={`nav-link ${isActive(['/admin-dashboard/menu-management', '/admin-dashboard/menu-detail'])}`} to="/admin-dashboard/menu-management">
                        <span className="nav-icon">
                            <img src="/assets/icons/restaurants.svg" alt="Menu" />
                            {/* <i class="fa-solid fa-house"></i> */}
                        </span>
                        <span className="nav-text">
                            Menu Management
                        </span>
                    </Link>
                </li>
                <li className="nav-item sidebar-link">
                    <Link className={`nav-link ${isActive([
                        '/admin-dashboard/suppliers-management',
                        '/admin-dashboard/supplier-detail'
                    ])}`} to="/admin-dashboard/suppliers-management">
                        <span className="nav-icon">
                            <img src="/assets/icons/suppliers.svg" alt="Suppliers" />
                            {/* <i class="fa-solid fa-house"></i> */}
                        </span>
                        <span className="nav-text">
                            Supplier's Management
                        </span>
                    </Link>
                </li>
                <li className="nav-item sidebar-link">
                    <Link className={`nav-link ${isActive(['/admin-dashboard/restaurants-management', '/admin-dashboard/restaurant-detail'])}`} to="/admin-dashboard/restaurants-management">
                        <span className="nav-icon">
                            <img src="/assets/icons/restaurants.svg" alt="Restaurants" />
                            {/* <i class="fa-solid fa-house"></i> */}
                        </span>
                        <span className="nav-text">
                            Restaurants Management
                        </span>
                    </Link>
                </li>
                <li className="nav-item sidebar-link">
                    <Link className={`nav-link ${isActive(['/admin-dashboard/customer-management', '/admin-dashboard/customer-detail'])} `} to="/admin-dashboard/customer-management">
                        <span className="nav-icon">
                            <img src="/assets/icons/customers.svg" alt="Customers" />
                            {/* <i class="fa-solid fa-house"></i> */}
                        </span>
                        <span className="nav-text">
                            Customer Management
                        </span>
                    </Link>
                </li>
                <li className="nav-item sidebar-link">
                    <Link className={`nav-link ${isActive(['/admin-dashboard/product-management'])} `} to="/admin-dashboard/product-management">
                        <span className="nav-icon">
                            <img src="/assets/icons/products.svg" alt="Products" />
                            {/* <i class="fa-solid fa-house"></i> */}
                        </span>
                        <span className="nav-text">
                            Product Management
                        </span>
                    </Link>
                </li>
                <li className="nav-item sidebar-link">
                    <button className={`nav-link droparrow position-relative ${activeOrder ? 'active' : ''} `} role="button" onClick={() => {
                        setOrderOpen(prev => !prev);
                        setActiveOrder(prev => !prev)
                    }}>
                        <span className="nav-icon">
                            <img src="/assets/icons/orders.svg" alt="Orders" />
                            {/* <i class="fa-solid fa-house"></i> */}
                        </span>
                        <span className="nav-text">
                            Order Management
                        </span>
                    </button>
                    <div className={`collapse ${orderOpen ? 'show' : ''}`}>
                        <ul className='list-unstyled mb-0'>
                            {/* <li><Link to="/admin-dashboard/order-management" className='nav-sublink'>Order List</Link></li> */}
                            <li><Link to="/admin-dashboard/order-management" state={{ role: "supplier" }} key={"supplier"} className={`nav-sublink`}>Supplier</Link></li>
                            <li><Link to="/admin-dashboard/order-management" state={{ role: "restaurant" }} key={"restaurant"} className={`nav-sublink`}>Restaurant</Link></li>
                            <li><Link to="/admin-dashboard/order-management" state={{ role: "customer" }} key={"customer"} className={`nav-sublink`}>Customer</Link></li>
                        </ul>
                    </div>
                </li>
                <li className="nav-item sidebar-link">
                    <Link className={`nav-link ${isActive(['/admin-dashboard/news-and-events-management'])} `} to="/admin-dashboard/news-and-events-management">
                        <span className="nav-icon">
                            <img src="/assets/icons/news.svg" alt="News" />
                            {/* <i class="fa-solid fa-house"></i> */}
                        </span>
                        <span className="nav-text">
                            News and Events Management
                        </span>
                    </Link>
                </li>
                <li className="nav-item sidebar-link">
                    <Link className={`nav-link ${isActive(['/admin-dashboard/content-management'])} `} to={`/admin-dashboard/content-management`}>
                        <span className="nav-icon">
                            <img src="/assets/icons/content.svg" alt="Content" />
                            {/* <i class="fa-solid fa-house"></i> */}
                        </span>
                        <span className="nav-text">
                            Content Management
                        </span>
                    </Link>
                </li>
                <li className="nav-item sidebar-link">
                    <Link className={`nav-link ${isActive(['/admin-dashboard/queries-management'])} `} to="/admin-dashboard/queries-management">
                        <span className="nav-icon">
                            <img src="/assets/icons/queries.svg" alt="Queries" />
                            {/* <i class="fa-solid fa-house"></i> */}
                        </span>
                        <span className="nav-text">
                            Queries Management
                        </span>
                    </Link>
                </li>
                <li className="nav-item sidebar-link">
                    <Link className={`nav-link ${isActive(['/admin-dashboard/send-notifications'])} `} to="/admin-dashboard/send-notifications">
                        <span className="nav-icon">
                            <img src="/assets/icons/notification.svg" alt="Notifications" />
                            {/* <i class="fa-solid fa-house"></i> */}
                        </span>
                        <span className="nav-text">
                            Send Notification
                        </span>
                    </Link>
                </li>
            </ul >
        </div >
    );
};

export default Sidebar;
